exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".scorestream_ui .rc-tooltip-content > .rc-tooltip-arrow {\n  display: none; }\n", ""]);

